import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BequestCardDataService {
  private key = 'charityCardData';

  customCharityWithOrgIdCity='';
  customCharityWithorgIdState='';
  addCharityOldData;
  featuredCardData;
  isCarddeletedRecently=false;

  deletedItems: any[] = [];

  private dataArraySubject = new BehaviorSubject<any[]>(this.getStoredData());
  dataArray$ = this.dataArraySubject.asObservable();

  private getStoredData(): any[] {
    const raw = localStorage.getItem(this.key);
    return raw ? JSON.parse(raw) : [];
  }

  private updateLocalStorage(data: any[]) {
    localStorage.setItem(this.key, JSON.stringify(data));
  }

  setData(data: any[]) {
    this.dataArraySubject.next(data);
    this.updateLocalStorage(data);
  }

  addItem(item: any, index?) {
    const current = this.dataArraySubject.getValue();
    const updated = [item, ...current];
    this.setData(updated);
    // const current = [...this.dataArraySubject.getValue()]; // clone to avoid mutating original
    // if (index + 1 !== undefined && index + 1 >= 0 && index + 1 <= current.length) {
    //   current.splice(index + 1, 0, item); // modifies the copy
    // } else {
    //   current.push(item); // fallback: add at end
    // }
    // this.setData(current); // now pass the modified array
  }

  updateItem(updatedItem: any) {
    const current = this.dataArraySubject.getValue();
    const updated = current.map(item =>
      item.customCharityId === updatedItem.customCharityId ? updatedItem : item
    );
    this.setData(updated);
  }

  deleteItem(customCharityId: string) {
    const current = this.dataArraySubject.getValue();
    const updated = current.filter(item => item.customCharityId !== customCharityId);
    this.setData(updated);
  }

  clearAll() {
    localStorage.removeItem(this.key);
    this.dataArraySubject.next([]);
  }

  deleteItems(customCharityIds: string[]) {
  const current = this.dataArraySubject.getValue();
  const updated = current.filter(item => !customCharityIds.includes(item.customCharityId));
  this.isCarddeletedRecently=true;
  this.setData(updated);

  }

  deleteOrgItem(orgId: string) {
    const current = this.dataArraySubject.getValue();
    const updated = current.filter(
      item => !(item.orgId === orgId && item.addedViaNewCharity === true)
    );
    const index = updated.findIndex( item => item.orgId==orgId ) 
    if(index>-1){
      const deletedData= updated.splice(index, 1);
      this.setData([...updated, ...deletedData])
    }
    else
    this.setData(updated);
  }

  addCharityhavingOrgId(item: any) {
    const current = this.dataArraySubject.getValue();
    const index = current.findIndex(obj => obj.orgId === item.orgId);

    let updated: any[];

    if (index > -1) {
      // orgId exists → remove it from current and place at the front
      const existingItem = current[index];
      current.splice(index, 1); // remove existing item
      updated = [existingItem, ...current]; // move to front
    } else {
      // orgId doesn't exist → add new item at the front
      if(item.orgId !=this.featuredCardData.orgId)
      updated = [item, ...current];
      else
      updated=[...current]
    }
    this.setData(updated);
  }
  setCityState(city, state){
    this.customCharityWithOrgIdCity=city;
    this.customCharityWithorgIdState=state;
  }
  getCityState(){
   let addr ={
    'city': this.customCharityWithOrgIdCity,
    'state': this.customCharityWithorgIdState
   }
    return(addr)
  }
  setFeaturedCardData(data){
    this.featuredCardData=data;
  }
  setCardData(data){
    this.addCharityOldData={...data};
    this.addCharityOldData['categoryName']=this.addCharityOldData['orgType'];
    this.addCharityOldData['addedViaNewCharityModal']=true;
    ['orgState', 'orgCity'].forEach(key => delete this.addCharityOldData[key]);
  }
  getCardData(){
    return(this.addCharityOldData);
  }
  deleteCardData(){
    this.addCharityOldData={};
  }

  deleteByOrgId(orgId) {
    const current = this.dataArraySubject.getValue();

    //storing the item to be deleted in local storage
    const toDelete = current.filter(
      item => item.orgId === orgId && item.isCardDeletionAllowed
    );
    if (toDelete.length > 0) {
      this.deletedItems.push(...toDelete);
      localStorage.setItem('deletedItems', JSON.stringify(this.deletedItems));
      const updated = current.filter(
        item => !(item.orgId === orgId && item.isCardDeletionAllowed)
      );

      const index = updated.findIndex(item => item.orgId == orgId)
      if (index > -1) {
        const deletedData = updated.splice(index, 1);
        this.setData([...updated, ...deletedData])
      }
      else
        this.setData(updated);
    }
  }

  clearData() {
    this.dataArraySubject.next([]);         // clear the BehaviorSubject
    this.addCharityOldData={};
    this.featuredCardData={};
  }

  mergeDeletedItemsIntoStoredData() {
    const key = 'charityCardData';
    const deletedKey = 'deletedItems';

    // Step 1: Get current stored charity data
    const storedRaw = localStorage.getItem(key);
    const charityData: any[] = storedRaw ? JSON.parse(storedRaw) : [];

    // Step 2: Get deleted items from localStorage
    const deletedRaw = localStorage.getItem(deletedKey);
    const deletedItems: any[] = deletedRaw ? JSON.parse(deletedRaw) : [];

    // Step 3: Merge only if not already present
    for (const deleted of deletedItems) {
      const exists = charityData.some(item =>
        (item.customCharityId && deleted.customCharityId && item.customCharityId === deleted.customCharityId) ||
        (!item.customCharityId && item.orgId && deleted.orgId && item.orgId === deleted.orgId)
      );

      if (!exists) {
        charityData.push(deleted);
      }
    }

    // Step 4: Save merged result back to localStorage
    localStorage.setItem(key, JSON.stringify(charityData));

    // Step 5 (optional): update observable stream
    this.dataArraySubject.next(charityData);
  }

isCardDeletedRecently(){
  return this.isCarddeletedRecently
}

cardNotDeleted(){
  this.isCarddeletedRecently=false;
}

}
